var api = {
  /**
   * 这里的参数和axios是一样的
   */
  login: {
    method: 'POST',
    path: process.env.VUE_APP_BASE_API + '/login/login.json',
    mock: false
  },

  getUserInfo: {
    method: 'GET',
    path: process.env.VUE_APP_BASE_API + '/user/userInfo.json',
    mock: false
  },
  orderOrderAmount: {
    method: 'get',
    path: process.env.VUE_APP_BASE_API + '/order/orderAmount.json',
    mock: false
  },
  orderGetTodayOrderCount: {
    method: 'get',
    path: process.env.VUE_APP_BASE_API + '/order/getTodayOrderCount.json',
    mock: false
  },
  orderGetStatusList: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/order/getStatusList.json',
    mock: false
  },
  orderOrderMonthStatistics: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/order/orderMonthStatistics.json',
    mock: false
  },
  // 分页获取客户地址
  addressGetPageList: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/address/getPageList.json'
  },
  addressUpdate: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/address/update.json'
  },
  addressAdd: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/address/add.json'
  },
  logisticsGetList: {
    method: 'get',
    path: process.env.VUE_APP_BASE_API + '/logistics/getList.json'
  },
  orderAdd: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/order/add.json'
  },
  orderGetOne: {
    method: 'get',
    path: process.env.VUE_APP_BASE_API + '/order/getOne.json'
  },
  orderCancel: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/order/cancel.json'
  },
  logisticsGetEstimateTimePrice: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/logistics/getEstimateTimePrice.json'
  },
  logisticsGetEstimatePrice: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/logistics/getEstimatePrice.json'
  },
  orderGetPickupDay: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/order/getPickupDay.json'
  },
  orderGetPickupTimeSlot: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/order/getPickupTimeSlot.json'
  },
  orderGetPageList: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/order/getPageList.json'
  },
  accountGetAccount: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/account/getAccount.json'
  },
  accountGetTransactionRecord: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/account/getTransactionRecord.json'
  },
  orderGetTicketCount: {
    method: 'get',
    path: process.env.VUE_APP_BASE_API + '/order/getTicketCount.json'
  },
  accountGetTransactionStatistics: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/account/getTransactionStatistics.json'
  },
  orderGetTotalOrderCount: {
    method: 'get',
    path: process.env.VUE_APP_BASE_API + '/order/getTotalOrderCount.json'
  },
  accountExportTransactionRecord: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/account/exportTransactionRecord.json'
  },
  accountExportTransactionStatistics: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/account/exportTransactionStatistics.json'
  },
  rechargeDo: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/recharge/do.json'
  },
  logisticsQueryRoute: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/logistics/queryRoute.json'
  },
  logisticsRecognizeLogisticsNumber: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/logistics/recognizeLogisticsNumber.json'
  },
  addressDelete: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/address/delete.json'
  },
  orderUpdatePickupTime: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/order/updatePickupTime.json'
  },
  complaintGetTypeList: {
    method: 'get',
    path: process.env.VUE_APP_BASE_API + '/complaint/getTypeList.json'
  },
  complaintAdd: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/complaint/add.json'
  },
  registerGetValidateCode: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/register/getValidateCode.json'
  },
  registerRegister: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/register/register.json'
  },
  addressRecognizeAddress: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/address/recognizeAddress.json'
  },
  enterpriseGetInfo: {
    method: 'get',
    path: process.env.VUE_APP_BASE_API + '/enterprise/getInfo.json'
  },
  enterpriseEdit: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/enterprise/edit.json'
  },
  logisticsGetUsableList: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/logistics/getUsableList.json'
  },
  logisticsSetExpress: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/logistics/setExpress.json'
  },
  departmentGetDepartment: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/department/getDepartmentTree.json'
  },
  departmentGetDepartmentList: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/department/getDepartmentList.json'
  },

  departmentAddDepartment: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/department/addDepartment.json'
  },
  departmentDelDepartment: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/department/delDepartment.json'
  },
  staffGetStaff: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/staff/getStaff.json'
  },
  staffDelStaff: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/staff/delStaff.json'
  },
  staffAddStaff: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/staff/addStaff.json'
  },
  staffResetStaffPwd: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/staff/resetStaffPwd.json'
  },
  enterpriseGetIndustryList: {
    method: 'get',
    path: process.env.VUE_APP_BASE_API + '/enterprise/getIndustryList.json'
  },
  enterpriseGetStaffRangeList: {
    method: 'get',
    path: process.env.VUE_APP_BASE_API + '/enterprise/getStaffRangeList.json'
  },
  logisticsGetUsableOne: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/logistics/getUsableOne.json'
  },
  addressGetExcelAddress: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/address/getExcelAddress.json'
  },
  orderBatchAdd: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/order/batchAdd.json'
  },
  orderGetNewestStatusList: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/order/getNewestStatusList.json'
  },
  orderOrderAmountLastWeek: {
    method: 'get',
    path: process.env.VUE_APP_BASE_API + '/order/orderAmountLastWeek.json'

  },
  orderExportOrderList: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/order/exportOrderList.json'
  },
  staffGetStaffList: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/staff/getStaffList.json'
  },
  orderGetSenderPageList: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/order/getSenderPageList.json'
  },
  customerBillGetCustomerBill: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/customerBill/getCustomerBill.json'
  },
  customerBillGetCustomerBillDetail: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/customerBill/getCustomerBillDetail.json'
  },
  customerBillExportCustomerBillDetail: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/customerBill/exportCustomerBillDetail.json'
  },
  staffGet: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/staff/get.json'
  },
  staffEdit: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/staff/edit.json'
  },
  staffGetValidateCode: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/staff/getValidateCode.json'
  },
  staffEditPassword: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/staff/editPassword.json'
  },
  staffEditMobile: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/staff/editMobile.json'
  },
  couponGetCouponList: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/coupon/getCouponList.json'
  },
  couponGetCoupon: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/coupon/getCoupon.json'
  },
  messageGetMessageList: {
    method: 'get',
    path: process.env.VUE_APP_BASE_API + '/message/getMessageList.json'
  },
  addressExportList: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/address/exportList.json'
  },
  loginFindPasswordCheckAccount: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/login/findPassword/checkAccount.json'
  },
  loginFindPasswordGetCode: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/login/findPassword/getCode.json'
  },
  loginFindPasswordCheckCode: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/login/findPassword/checkCode.json'
  },
  loginfindPasswordEditPassword: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/login/findPassword/editPassword.json'
  },
  orderReadOrderMsg: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/order/readOrderMsg.json'
  },
  xzlmSendCoupon: {
    method: 'get',
    path: process.env.VUE_APP_BASE_API + '/xzlm/sendCoupon'
  },
  addressAddDefaultAddress: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/address/addDefaultAddress.json'
  },
  wxGetRedirectUrl: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/wx/getRedirectUrl.json'
  },
  orderGetInitPickupDayTimeSlot: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/order/getInitPickupDayTimeSlot.json'
  },
  orderGetDefaultSenderAddress: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/order/getDefaultSenderAddress.json'
  },
  logisticsGetSelectableShipperList: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/logistics/getSelectableShipperList.json'
  },
  logisticsGetPcSelectableShipperList: {
    method: 'post',
    path: process.env.VUE_APP_BASE_API + '/logistics/getPcSelectableShipperList.json'
  },
  
}
module.exports = api
